/**
 * Shop-Identitaet des Frontends — die EINE Stelle, aus der Kundenseiten,
 * Admin-Vorschauen und Links Name, Logo, Farben und Link-Basis beziehen.
 *
 * Werte kommen aus REACT_APP_*-Variablen (`.env` bzw. `.env.lomae`), werden
 * also beim Bauen eingebrannt: `npm run build` fuer Printsonalities,
 * `npm run build:lomae` fuer Lomae. Die Standardwerte sind exakt die
 * bisherigen Printsonalities-Werte, damit sich dort nichts aendert.
 *
 * Hintergrund (13.09.2026): Die Lomae-Kundenseite zeigte ein kaputtes Logo
 * (Pfad ohne fuehrenden Schraegstrich, relativ zu /order-review/... aufgeloest),
 * die Printsonalities-Farben, und der Link in der Admin-Uebersicht fuehrte auf
 * review.printsonalities.de — alles Literale, verteilt ueber ein Dutzend
 * Dateien.
 *
 * Die Link-Basis ist bewusst NICHT konfiguriert, sondern der Ursprung der
 * laufenden Seite: Admin und Kundenseiten werden vom selben Host
 * ausgeliefert (review.printsonalities.de bzw. review.lomae.de), ein Link
 * kann also nur dorthin richtig sein. Lokal (localhost:3000) zeigt er auf
 * die lokale Seite, was fuer Vorschauen genau richtig ist.
 */

const env = (key, fallback) => {
  const v = process.env[key];
  return v && String(v).trim() ? String(v).trim() : fallback;
};

// Logo-Pfade in .env sind teils ohne fuehrenden Schraegstrich hinterlegt
// ("logo-lomae.svg"). Als relativer Pfad wuerde er unter /order-review/...
// zu /order-review/logo-lomae.svg — ein 404. Immer absolut machen.
const absolute = (p) => (/^(https?:)?\/\//.test(p) || p.startsWith("/") ? p : `/${p}`);

export const SHOP = {
  name: env("REACT_APP_SHOP_NAME", "Printsonalities"),
  // Shop-Kuerzel bei Etsy (URL-Teil), z. B. "Printsonalities" / "LomaeDesign".
  etsyShop: env("REACT_APP_ETSY_SHOP", "Printsonalities"),
  logo: absolute(env("REACT_APP_LOGO", "/logo.png")),
  // Adresse, die in Vorschauen und Fusszeilen genannt wird.
  email: env("REACT_APP_SHOP_EMAIL", "gestaltung@printsonalities.de"),
  // Farben der Kundenseiten und der E-Mail-Vorschauen — gleiche Rollen wie
  // config/shopSettings der Cloud Functions (brandColor, emailBackground,
  // emailBorder, accentSoft), damit Vorschau und echte Mail zusammenpassen.
  primary: env("REACT_APP_PRIMARY_COLOR", "#4a2c2a"),   // Buttons, Ueberschriften
  accent: env("REACT_APP_ACCENT_COLOR", "#B8A09A"),     // Markenfarbe, Linien
  accentSoft: env("REACT_APP_ACCENT_SOFT", "#c8a882"),  // Zitatbalken, Akzente
  pageBg: env("REACT_APP_PAGE_BG", "#fdf7f4"),          // Seitenhintergrund
  border: env("REACT_APP_BORDER_COLOR", "#e8d8d0"),     // Rahmen, Trennlinien
};

/** Basis fuer Links auf Kundenseiten — der Host, auf dem diese App laeuft. */
export const reviewBase = () =>
  env("REACT_APP_REVIEW_BASE", null) ||
  (typeof window !== "undefined" && window.location && window.location.origin) ||
  "https://review.printsonalities.de";

export const reviewUrl = (draftId) => `${reviewBase()}/review/${draftId}`;
export const orderReviewUrl = (tokenOrId) => `${reviewBase()}/order-review/${tokenOrId}`;
